import { ANALYTICS_DASHBOARD_URL, CREATE_USER_MERCHANT, NO_VENUES, VENUES, VENUES_OVERVIEW } from "../const/URL.const";

const IGNORED_ROUTES = [VENUES, NO_VENUES, CREATE_USER_MERCHANT];

const { parseRedirectURL } = routeParser(IGNORED_ROUTES);
export const parseVenueUrl = parseRedirectURL;

const ROOT_IGNORED = [...IGNORED_ROUTES, VENUES_OVERVIEW];
const { parseRedirectURL: parse } = routeParser(ROOT_IGNORED);
export const parseMainRoute = parse;

function routeParser(ignoredRoutes: string[]) {
    function parseRedirectURL(redirectURL: string | null) {
        if (redirectURL && ignoredRoutes.indexOf(redirectURL) === -1) {
            return redirectURL;
        }
        return ANALYTICS_DASHBOARD_URL;
    }
    return {
        parseRedirectURL
    }
}